var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcRoundLogoMiso = function SvgIcRoundLogoMiso(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47 54",
    style: {
      enableBackground: "new 0 0 47 54"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.5,
    y1: -3.3448,
    x2: 23.5,
    y2: 47.4707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003947586,
    style: {
      stopColor: "#4FEEAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#44C6A7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,50.4H6.9c-3.8,0-6.9-3.1-6.9-6.9V10.4c0-3.8,3.1-6.9,6.9-6.9h33.1c3.8,0,6.9,3.1,6.9,6.9v33.1 C46.9,47.4,43.9,50.4,40.1,50.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iy5lxF.tif_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.5,
    y1: 6.3575,
    x2: 23.5,
    y2: 45.5358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003430886,
    style: {
      stopColor: "#FDFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D2FFF3"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.2,10c-1.3,2.7-0.9,5,1.4,6.9c1,0.8,2.2,1.1,3.5,1c1.3-0.1,2.4-0.6,3.3-1.6c0.1,0.2,0.3,0.4,0.4,0.5 c5,8.7,0.3,19.8-9.5,22.3c-1,0.3-1.9,0.7-2.6,1.6c-0.8,1-1,2.1-0.8,3.4c0,0.2,0.2,0.5-0.1,0.6c-0.3,0.1-0.4-0.2-0.5-0.4 c-0.9-1.5-1.8-3.1-2.7-4.6c-0.2-0.3-0.4-0.4-0.7-0.5C13.7,37.8,9,32.4,8.3,26.1c-0.8-7.8,4.3-14.9,12-16.6 c2.5-0.5,5-0.4,7.4,0.3c0.1,0,0.2,0.1,0.3,0.1C28.1,9.9,28.1,10,28.2,10z M23.6,20.8c-0.2-0.2-0.3-0.3-0.4-0.5 c-1.2-1.3-3.1-1.7-4.8-1c-1.7,0.8-2.6,2.2-2.6,4c0,2.1,0,4.3,0,6.4c0,0.2,0,0.3,0,0.5c0.2,1.1,1.6,1.6,2.5,0.9 c0.4-0.3,0.6-0.8,0.6-1.3c0-0.8,0-1.7,0-2.5c0-1.3,0-2.5,0-3.8c0-0.7,0.5-1.4,1.3-1.5c0.7-0.1,1.5,0.2,1.8,0.9 c0.1,0.3,0.2,0.6,0.2,0.8c0,2,0,4.1,0,6.1c0,0.9,0.7,1.6,1.5,1.6c0.9,0,1.5-0.7,1.5-1.6c0-0.4,0-0.8,0-1.3c0-1.7,0-3.4,0-5 c0-0.8,0.6-1.4,1.3-1.6c0.7-0.1,1.5,0.2,1.8,0.9c0.1,0.3,0.1,0.6,0.1,0.8c0,2,0,4,0,6c0,0.4,0.1,0.8,0.4,1.2 c0.4,0.5,1.1,0.7,1.7,0.4c0.6-0.2,1-0.8,1-1.5c0-2.2,0.1-4.5,0-6.7c-0.1-1.9-1-3.3-2.8-3.9c-1.8-0.6-3.4-0.2-4.7,1.1 C23.7,20.6,23.6,20.7,23.6,20.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.6326,
    y1: 6.3575,
    x2: 32.6326,
    y2: 45.5358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003430886,
    style: {
      stopColor: "#FDFFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D2FFF3"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.3,12.7c0,1.5-1.2,2.7-2.6,2.7c-1.5,0-2.7-1.2-2.7-2.7c0-1.4,1.2-2.6,2.6-2.6 C34.1,10.1,35.3,11.3,35.3,12.7z"
  })))))));
};
export default SvgIcRoundLogoMiso;